import { useEffect, useRef, useState } from 'react'

import { Box, Button, Paper, useTheme, Typography, Icon, Grid, LinearProgress } from '@mui/material'
import { FormControlLabel, Switch } from '@mui/material';

import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";

import { AutoCompleteDeSetor } from '../../shared/components/autocompletes/AutoCompleteDeSetor';
import { IListagemTipo } from '../../shared/services/api/tipo/TipoService';
import { LayoutBaseDePagina } from '../../shared/layouts'
import { DocumentoService, IIndice_Documento } from '../../shared/services/api/documento/DocumentoService';
import { ITipo_Indice_Documento, Tipo_Indice_Service } from '../../shared/services/api/tipo_indice/Tipo_Indice_Service';
import { useParams } from 'react-router-dom';
import { AlertSnackBar } from '../../shared/components';
import { Environment } from '../../shared/environment';
import React from 'react';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';
import DocumentViewer from '../../shared/components/visualizador-de-documento/DocumentViewer';
import { IndicesCadastro } from '../../shared/components/indices/IndicesCadastro';
import { ListagemTipos } from '../../shared/components/dialog/tipos/ListagemTipos';



export const IndexarDocumento: React.FC = () => {
  const { idCaixa = "null" } = useParams<'idCaixa'>();
  const { localizador = "null" } = useParams<'localizador'>();
  const { codigoBarras = "null" } = useParams<'codigoBarras'>();
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(false);

  const [idSetor, setIdSetor] = useState<number | undefined>(undefined);

  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfFileType, setPdfFileType] = useState<string>("");

  const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [indexar, setIndexar] = useState(false);

  const [file, setFile] = useState<FormData>();

  useEffect(() => { setIdSetor(Number(localStorage.getItem("idSetor"))) }, [])
  useEffect(() => { setIdTipo(0) }, [idSetor])

  //@ts-expect-error
  const handleArquivo = (event) => {
    if (event.target.files?.length === 1) {
      if (!!event.target.files[0]) {
        //@ts-expect-error
        setPdfFile(URL.createObjectURL(event.target.files[0]));
        setPdfFileType(event.target.files[0].type || null);
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
        setFile(undefined);
      }
    }
    else if (event.target.files?.length > 1) {
      const files = event.target.files;

      const arquivo = new FormData();
      for (let i = 0; i < files.length; i++) {
        arquivo.append('arquivos', files[i]);
      }
      setPdfFile(null)
      setPdfFileType("");
      setFile(arquivo);
      setSelectedFile(undefined);
      setIsFilePicked(false);
    }
  };

  //-------------------------------------------------------------------------------------  Parte dos tipos -------------------------------------------------------------------------------------


  const [rowsTipo, setRowsTipo] = useState<IListagemTipo[]>([]);
  const [openDialog, setOpenDialog] = useState(false);

  const [idTipo, setIdTipo] = useState<number>(0);
  const [nomeTipo, setNomeTipo] = useState<string>("");

  const [reset, setReset] = useState<boolean>(false);

  const limparCampos = () => {
    setSelectedFile(undefined);
    setIsFilePicked(false);

    var auxVal: string[] = [];
    rowsIndice.map(() => {
      auxVal.push("");
    });

    setValores(auxVal);
    setReset(true);
    setTimeout(() => setReset(false), 0);
    setPdfFile(null);
    setPdfFileType("");
    setFile(undefined);
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleConfirmar = () => {
    handleClose();
  };

 //----------------------------------------------------------------------------------  Parte dos Índices ---------------------------------------------------------------------------------
  const [rowsIndice, setRowsIndice] = useState<ITipo_Indice_Documento[]>([]);
  const [isLoadingIndice, setIsLoadingIndice] = useState(false);

  const pegarNomeTipo = (rowsTipo: IListagemTipo[]): string => {
    var nome = rowsTipo.find(tipo => tipo.idTipo === idTipo)?.nomeTipo ?? "";

    if (nome === "") {
      for (let i = 0; i < rowsTipo.length; i++) {
        if (rowsTipo[i].tipos) {
          nome = pegarNomeTipo(rowsTipo[i].tipos);
          if (nome !== "") {
            break;
          }
        }
      }
    }
    return nome;
  };

  useEffect(() => {
    setRowsIndice([]);
    if (idTipo !== 0) {

      setNomeTipo(pegarNomeTipo(rowsTipo));

      setIsLoadingIndice(true);
      Tipo_Indice_Service.getByIdTipo(idTipo, false).then((result) => {
        setIsLoadingIndice(false);
        if (result instanceof Error) {
          setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);
          // alert(result.message);
        } else {
          setRowsIndice(result);

          var auxVal: string[] = [];
          result.map(() => {
            auxVal.push("");
          });

          setValores(auxVal);
        }
      });
    }
  }, [idTipo])

  const [valores, setValores] = useState<string[]>([]);

  //-------------------------------------------------------------------------------  Fim da parte dos Índices -----------------------------------------------------------------------------
  const formRef = useRef<FormHandles>(null);
  const handleSave = () => {

    if (idTipo !== 0) {

      if (selectedFile || file) {

        if (!valores.every(elemento => elemento === '') || (idCaixa !== "" && idCaixa !== undefined && idCaixa !== "null" && idCaixa !== null && idCaixa !== "0")) {

          if (!valores.some(elemento => elemento === '')) {
            persistirDados();
          }
          else if (valores.length !== 0) {
            setConfirmacaoIndices(true);

          }
        } else {

          setAlertSnackbar({ tipoAlert: "erro", mensagem: "Preencha no mínimo um índice" });
          setTimeout(() => {
            setAlertSnackbar(undefined);
          }, duracaoAlert);

        }
      } else {
        setConfirmacaoIndices(false);
        setAlertSnackbar({ tipoAlert: "erro", mensagem: "É obrigatório selecionar um arquivo" });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);

      }
    } else {
      setConfirmacaoIndices(false);
      setAlertSnackbar({ tipoAlert: "erro", mensagem: "É obrigatório selecionar um tipo" });
      setTimeout(() => {
        setAlertSnackbar(undefined);
      }, duracaoAlert);
    }
  }

  const persistirDados = () => {

    setConfirmacaoIndices(false);
    setIsLoading(true);

    var arquivo = new FormData();
    if (selectedFile) {
      arquivo.append('arquivos', selectedFile);

    } else if (file !== undefined) {
      arquivo = file;
    }

    DocumentoService.createList(arquivo, idTipo, idCaixa).then((resultDocumento) => {

      if (resultDocumento instanceof Error) {

        setIsLoading(false);
        setAlertSnackbar({ tipoAlert: "erro", mensagem: resultDocumento.message });
        setTimeout(() => {
          setAlertSnackbar(undefined);
        }, duracaoAlert);

      } else {

        var dadosIndice: IIndice_Documento[] = [];

        rowsIndice.map((indice, index) => {
          var valor: string | null = valores[index];
          var dataInicial: string | null = null;
          var dataFinal: string | null = null
          if (indice.idComponente === 5) {
            valor = null;
            dataInicial = valores[index];
          }
          if (indice.idComponente === 6) {
            valor = null;
            dataInicial = valores[index].split(" | ")[0];
            dataFinal = valores[index].split(" | ")[1];
          }

          if (indice.idComponente === 4 && valor !== '' && valor !== undefined && valor !== null) {// se for checkbox
            var aux = valor.split(", ");// transforma em array
            aux.pop();// retira a ultima posição(virgula com espaço)
            valor = aux.join(", ");// tranforma em string adicionando virgula e espaco entre cada elemento
          }
          resultDocumento.forEach(id => {

            dadosIndice.push({
              idDocumento: id,
              idIndice: indice.idIndice,
              valor: valor,
              dataInicial: dataInicial,
              dataFinal: dataFinal,
            });
          });

        });

        DocumentoService.createIndice_Documento(dadosIndice).then((resultIndices) => {
          setIsLoading(false);

          if (resultIndices instanceof Error) {
            setAlertSnackbar({ tipoAlert: "erro", mensagem: resultIndices.message });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);

          } else {
            limparCampos();
            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Documento cadastrado com sucesso" });
            setTimeout(() => {
              setAlertSnackbar(undefined);
            }, duracaoAlert);

            if (indexar) {

              setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Indexação do conteudo iniciada" });
              setTimeout(() => {
                setAlertSnackbar(undefined);
              }, duracaoAlert);

              DocumentoService.indexarList(resultDocumento).then((resultIndexar) => {

                if (resultIndexar instanceof Error) {

                  setAlertSnackbar({ tipoAlert: "erro", mensagem: resultIndexar.message });
                  setTimeout(() => {
                    setAlertSnackbar(undefined);
                  }, duracaoAlert);

                } else {

                  setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Indexação do conteudo finalizada" });
                  setTimeout(() => {
                    setAlertSnackbar(undefined);
                  }, duracaoAlert);

                }
              });
            }

          }

        });
      }
    });


  }

  const handleValoresAlterarChange = (novosValores: string[]) => {
    setValores(novosValores);
  };

  const [abrirConfirmacaoIndices, setConfirmacaoIndices] = useState<boolean>(false);

  return (
    <LayoutBaseDePagina titulo="Indexar documento" barraDeFerramentas={
      <>
        <Box
          component={Paper}
          height={theme.spacing(5)}
          marginX={1}
          padding={1}
          paddingX={2}
          display="flex"
          gap={1}
          alignItems="center"
        >
          {alertSnackbar !== undefined && (
            <>
              {alertSnackbar.tipoAlert === "sucesso" && (
                <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
              )}
              {alertSnackbar.tipoAlert === "erro" && (
                <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
              )}
              {alertSnackbar.tipoAlert === "aviso" && (
                <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
              )}
            </>
          )}

          {idCaixa === "null" && <AutoCompleteDeSetor selectedIdSetor={selectedIdSetor => setIdSetor(selectedIdSetor)} />}

          <Button variant="contained" onClick={handleClickOpen} disabled={isLoading || !idSetor}>
            <Typography variant='button' noWrap> Mostrar tipos </Typography>
          </Button>

          <FormControlLabel control={
            <Switch disabled={isLoading} checked={indexar} onChange={e => setIndexar(e.target.checked)} />
          }
            label="Indexar conteúdo"
          />

          <Box flex="1" display="flex" justifyContent="end" gap={1}>
            <Button variant="contained" startIcon={<Icon>save</Icon>} onClick={handleSave} disabled={isLoading} color="primary" disableElevation>
              <Typography variant='button' noWrap>
                Salvar
              </Typography>
            </Button>
          </Box>
        </Box>
        
        <ListagemTipos
          abrir={openDialog}
          idSetor={idSetor ?? 0}
          setIdTipo={setIdTipo}
          setRowsTipo={(row) => setRowsTipo(row)}
          txtTooltip="Para que um tipo seja listado aqui, é necessário que tenha no mínimo 1 (um) índice de DOCUMENTO"
          AoConfirmar={handleConfirmar}
          AoCancelar={handleClose}
        />

        <DialogConfirm
          abrir={abrirConfirmacaoIndices}
          titulo='Nem todos os índices foram informados'
          texto='Deseja continuar a indexação mesmo assim?'
          AoConfirmar={() => persistirDados()}
          AoCancelar={() => setConfirmacaoIndices(false)}
        />
      </>
    }>
      <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
        <Form ref={formRef} onSubmit={handleSave}>
          <Grid container direction="column" padding={2} spacing={2}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            {localizador !== "null" && (
              <Grid container item direction="row" spacing={2}>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography> Localizador da caixa: <b>{localizador}</b> </Typography>
                </Grid>

              </Grid>
            )}
            {codigoBarras !== "null" && (
              <Grid container item direction="row" spacing={2}>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography> Código de barras da caixa: <b>{codigoBarras}</b> </Typography>
                </Grid>

              </Grid>
            )}
            {idTipo !== 0 && (
              <Grid container item direction="row" spacing={2}>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography> Este documento será do tipo: <b>{nomeTipo}</b> </Typography>
                </Grid>

              </Grid>
            )}
            <Grid container item direction="column" spacing={2}>
              <Grid container item direction="row" spacing={2}>

                <Grid item>
                  <Box display="flex" gap={1} alignItems="center">
                    <Button
                      variant="contained"
                      component="label"
                      disabled={isLoading || !idTipo}
                    >
                      Selecionar arquivo
                      <input
                        type="file"
                        accept='application/pdf, image/tiff, image/tif'
                        hidden
                        multiple
                        onChange={handleArquivo}
                      />
                    </Button>

                    {isFilePicked && selectedFile &&
                      //@ts-expect-error
                      <Typography> {selectedFile.name} </Typography>
                    }

                    {!isFilePicked && file === undefined &&
                      <Typography> Nenhum arquivo selecionado </Typography>
                    }

                    {file &&
                      <Typography> {Array.from(file.values()).filter(value => value !== "").length} arquivos selecionados </Typography>
                    }
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {rowsIndice.length > 0 && (
            <Typography sx={{ m: 2 }} variant="h4"> Índices </Typography>
          )}
          <Grid container direction="column" padding={2} spacing={2}>

            <Grid container item direction="row" spacing={2}>

              {isLoadingIndice && (
                <Grid item xs={12}>
                  <LinearProgress variant='indeterminate' />
                </Grid>
              )}

              <IndicesCadastro aoSalvar={() => handleSave} rowsAlterarValorIndice={rowsIndice} onValoresAlterarChange={handleValoresAlterarChange} reset={reset} />

            </Grid>
          </Grid>

          <Grid textAlign="center">
            {pdfFile && <DocumentViewer arquivo={pdfFile} mimeType={pdfFileType} />}
          </Grid>

        </Form>
      </Box>
    </LayoutBaseDePagina >
  )
}